import React from 'react'
import Section from '../Section'
import Button from 'components/Button'
import s from './TextBanner.scss'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'
import cn from 'classnames'
import analytics from 'features/Analytics/Analytics.utils'

export default props => {
  const contactUsHandler = () => {
    analytics.track('Contact Us - Button Click')

    if (window.Intercom) window.Intercom('show')
  }

  const button =
    props.buttonText === 'Contact Us' ? (
      <Button
        color={props.color === 'accent' ? 'primary' : 'tertiary'}
        size="lg"
        style={{ margin: '30px 0' }}
        onClick={contactUsHandler}
      >
        {props.buttonText}
      </Button>
    ) : (
      <Button
        color={props.color === 'accent' ? 'primary' : 'tertiary'}
        size="lg"
        to={props.buttonTo}
        style={{ margin: '30px 0' }}
      >
        {props.buttonText}
      </Button>
    )

  return (
    <Section
      color={props.color}
      paddingTop={props.paddingTop === undefined ? '30px' : props.paddingTop}
      paddingBottom={props.paddingBottom === undefined ? '30px' : props.paddingBottom}
    >
      <div
        className={cn(
          props.centerText ? sLay['layout-gt-xs-column'] : sLay['layout-gt-xs-row'],
          sLay['layout-align-gt-xs-start-center'],
          sLay['layout-xs-column'],
          sLay['layout-align-xs-center-center']
        )}
      >
        <div className={cn(sText.heading3, sLay.flex, s.text)} style={{ margin: '30px 0' }}>
          {props.title}
        </div>
        {props.buttonText && button}
      </div>
    </Section>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/TextBanner/TextBanner.jsx